import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../../../../services/common';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SalesService } from '../../../sales.service';
import { coApplicantColDefs, familyColDefs, IFormInfo, nomineeColDefs, otherChargesColDefs, paymentSchedule, referenceList, References, summaryTreeNodes } from '../allotment-addupdate.model';
import { AmountSubTypes, DocumentSubType, UserSubType } from '../../../../../../appconfig';
import { environment } from '../../../../../../environments/environment';
import { IconList } from '../../../../../../iconlist';
import { FormIdentity, ICommonFormField } from '../../../../../common-components/common-form/common-form.model';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { JwtService } from '../../../../../auth/jwtservice';
import { ActivatedRoute } from '@angular/router';
import { isDateValid } from 'ngx-bootstrap/chronos';
import { error } from 'jquery';

@Component({
  selector: 'app-basic-details',
  templateUrl: './basic-details.component.html',
  styleUrl: './basic-details.component.scss'
})
export class BasicDetailsComponent implements OnInit, OnChanges {
  @Input() allotmentRelatedData: any;
  @Input() formGroup!: FormGroup;
  @Output() basicDetailData = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<void>();
  Submitted = false;
  OtherFormSubmitted = true;
  isSubmitting: boolean = false

  selectedUnitCategory: any;
  currentUnitCategoryObj: any

  selectedReference: any;
  showClientIcon: boolean = false;
  clientList: any;
  showOverlay: boolean = false;
  customerIcon: any = environment.assetsImagePath + IconList.UserIcon;
  genders: any[] = [];
  uidTypeList: any[] = [];
  filteredUnitDescriptions: any[] = [];
  mandatoryAmountSubType: any[] = []
  eligibleAmountSubTypeList: any[] = [];
  selectedUnitDescription: any;
  maxDate!: Date;
  selectedTaxName: any;
  // selectedTaxStructureForNewRecord: any;
  selectedRowDataToEdit: any = null;

  dateOfBirth!: Date;
  anniversaryDate!: Date;
  bookingDate!: Date;
  allotmentDate!: Date;
  firmDetails = false;
  showAdressModal: boolean = false;
  hideSearchBar: boolean = true;
  isOtherChargesIncluded: boolean = true;
  isSubmitDisabled: boolean = false;
  formDataConfig: any = null;
  showDetailedModal: boolean = false;
  familyColumnDefs: any[] = [];
  coApplicantColumnDefs: any[] = [];
  nomineeColumnDefs: any[] = [];
  coAppRowData: any;
  familyRowdata: any;
  nomineeRowData: any;
  coapplicantDetails = false;
  nomineeDetails = false;
  referenceList: any[] = referenceList;
  saleRate = 0;
  selectedPaymentPlan: any;
  formIdentity!: FormIdentity;
  currentPaymentScheduledDataRows: any[] = [];
  receivedBasicDetailsData: any;
  selectedOtherChargesHead: any;
  selectedOtherChargeAmountRate: any;
  selectedNonMandatoryOtherChargesHead: any;


  showOtherChargesModal: boolean = false;
  otherChargesRowData: any;
  otherChargesColumnDefs: any[] = [];
  projectDefaultData: any;
  defaultbasicSalePrice = 0;
  nonMandatoryOtherCharges: any[] = [];
  defaultplcData: any[] = [];


  paymentScheduleColumnDefs: any[] = paymentSchedule;

  summaryColumnDefs!: any[];
  summaryData: any[] = [];
  columns: any = [
    {
      field: 'selection',
      columnType: 'radio'
    },
    {
      header: 'Client Name', columnType: 'text', field: 'clientName'
    }
    ,
    { header: 'Pan Card No.', field: 'panCardNo', columnType: 'text' },
    {
      header: 'Contact No.',
      field: 'primaryPhoneNo',
      columnType: 'text'
    },
  ];

  discountValue: number = 0.0;
  otherChargeForm!: FormGroup;
  taxableAmount: number = 0.0;
  grossAmount: number = 0.0;
  roundOffGrossAmount: number = 0.0;
  totalTaxAmount: number = 0.0;
  totalAmount: number = 0.0;
  igstValue: number = 0.0;
  dividedRateOfTaxStructure: number = 0.0;
  cgstValue: number = 0.0;
  sgstValue: number = 0.0;
  maxDiscount: number = 0.0;
  isDisabledCharges = true;
  roleList: any;
  isAuthForDiscount = false;
  discoutsubTypeObject: any;

  roleListData: any; //total roles current user has
  discountSubTypeList: any; //total discounts available for a particular amount sub type
  eligibleDiscountList: any[] = [];  // discounts for which current user is eligible
  currentAllotmentObject: any;
  deleteIcon: string = environment.assetsImagePath + IconList.DeleteIcon
  editIcon: string = environment.assetsImagePath + IconList.EditIconDropdown;
  isEditOtherRow = false;
  bookingId: any;
  constructor(public commonService: CommonService, private toastr: ToastrService, private fb: FormBuilder,
    public salesService: SalesService, private cdr: ChangeDetectorRef, public jwtService: JwtService,
    private route: ActivatedRoute) {
    this.roleList = this.jwtService.currentUserRolesValue
    this.basicDetailData.emit();
    this.otherChargesColumnDefs = otherChargesColDefs;
    this.maxDate = new Date();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes as any).selectedUnitCategory && !(changes as any).selectedUnitCategory) {
      this.otherChargesRowData = null
    };

    if (this.allotmentRelatedData.amountSubTypesAgainstProject) {
      this.eligibleAmountSubTypeList = this.allotmentRelatedData?.amountSubTypesAgainstProject
    }
  }

  ngOnInit() {
    this.showClientIcon = false;

    this.init();
    this.initOtherChargeForm();
    this.getUIDTypeList();
    this.getGenders();
    this.getRoleList();
    this.formGroup = this.fb.group({
      pan: [''],
      aadharNumber: [''],
      crmRefLeadId: [null],
      clientId: [null],
      referenceNumber: [''],
      sourceType: [''],
      sourceName: [''],
      nameInitialsId: [''],
      firstName: [''],
      lastName: [''],
      relationInitialsId: [''],
      parentName: [''],
      gender: [''],
      bloodGroup: [''],
      nationality: [''],
      email: [''],
      contactNumber: [''],
      secondaryPhoneNo: [''],
      saleRate: [''],
      taxStructure: [''],
      paymentPlan: [''],
      bookingDate: [''],
      allotmentDate: [''],
      unitCategory: [''],
      unitDescription: [''],
      dateOfBirth: [''],
      weddingAnniversary: ['']
    })
    this.bookingId = this.route.snapshot.paramMap.get("bookingId");

    this.salesService.allotmentBasicDetailData$.subscribe((data) => {
      this.receivedBasicDetailsData = data;
    });

    if (this.allotmentRelatedData.amountSubTypesAgainstProject) {
      this.eligibleAmountSubTypeList = this.allotmentRelatedData?.amountSubTypesAgainstProject
    }
    //nonMandatory other charges list to be bind in dropdown for add other charge
    this.nonMandatoryOtherCharges = this.filterAmountSubTypeList(false) //this.allotmentRelatedData.amountSubTypesAgainstProject;//.filter((data: any) => data.isMandatory === false);
    this.otherChargesRowData = this.getOtherChargesData() || [];
  }

  closeOtherChargesModal() {
    this.showOtherChargesModal = false;
  }

  initOtherChargeForm() {
    this.otherChargeForm = this.fb.group({
      amountSubType: [null, Validators.required],
      superArea: [0.0],
      amountRate: [0, Validators.required],
      amount: [0.0],
      allDiscounts: this.fb.array([]),
      discount: [0.0],
      taxableAmount: [0.0],
      igstRate: [0.0],
      cgst: [0.0],
      sgst: [0.0],
      taxAmount: [0.0],
      otherTaxType: [null, Validators.required],
      grossAmount: [0.0],
      roundOff: [0.0],
      netAmount: [0.0]
    });
  }

  familyMemberDetailsConfig: any[] = [
    { name: 'nameInitails', label: 'Name Initial', type: 'dropdown', options: ['Mr.', 'Mrs.', 'Miss.', 'Dr.', 'Sh.', 'Smt.'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'firstName', label: 'First Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'lastName', label: 'Last Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'contact', label: 'Contact Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'email', label: 'Email', type: 'email', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'dob', label: 'Date of Birth', type: 'date', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'relation', label: 'Relation', type: 'dropdown', options: ['Father', 'Mother', 'Sibling'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'gender', label: 'Gender', type: 'dropdown', options: ['Male', 'Female', 'Other'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidType', label: 'UID Type', type: 'dropdown', options: ['Aadhaar', 'Passport', 'Voter ID'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidNumber', label: 'UID Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'bloodGroup', label: 'Blood Group', type: 'dropdown', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], validations: { required: true, minLength: 10, maxLength: 50 } }
  ];

  coApplicantDetailsConfig: ICommonFormField[] = [
    { name: 'firstName', label: 'First Name', value: null, type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'lastName', label: 'Last Name', value: null, type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'contact', label: 'Contact Number', value: null, type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'email', label: 'Email', value: null, type: 'email', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'dob', label: 'Date of Birth', value: null, type: 'date', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'relation', label: 'Relation', value: null, type: 'dropdown', options: [{ label: 'Father', value: 'Father' }, { label: 'Mother', value: 'Mother' }, { label: 'Sibling', value: 'Sibling' }], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'gender', label: 'Gender', value: null, type: 'dropdown', options: [{ label: 'Male', value: 'Male' }, { label: 'Female', value: 'Female' }, { label: 'Other', value: 'Other' }], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidType', label: 'UID Type', value: null, type: 'dropdown', options: [{ label: 'Aadhaar', value: 'Aadhaar' }, { label: 'Passport', value: 'Passport' }, { label: 'Voter ID', value: 'VoterID' }], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidNumber', label: 'UID Number', value: null, type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'bloodGroup', label: 'Blood Group', value: null, type: 'dropdown', options: [{ label: 'A+', value: 'A+' }, { label: 'A-', value: 'A-' }, { label: 'B+', value: 'B+' }, { label: 'B-', value: 'B-' }, { label: 'AB+', value: 'AB+' }, { label: 'AB-', value: 'AB-' }, { label: 'O+', value: 'O+' }, { label: 'O-', value: 'O-' }], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'weddingAnniversary', label: 'Wedding Anniversary', value: null, type: 'date', validations: { required: true, minLength: 10, maxLength: 50 } }
  ]

  nomineeDetailsConfig: any[] = [
    { name: 'firstName', label: 'First Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'lastName', label: 'Last Name', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'contact', label: 'Contact Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'email', label: 'Email', type: 'email', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'dob', label: 'Date of Birth', type: 'date', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'relation', label: 'Relation', type: 'dropdown', options: ['Father', 'Mother', 'Sibling'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'gender', label: 'Gender', type: 'dropdown', options: ['Male', 'Female', 'Other'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidType', label: 'UID Type', type: 'dropdown', options: ['Aadhaar', 'Passport', 'Voter ID'], validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'uidNumber', label: 'UID Number', type: 'text', validations: { required: true, minLength: 10, maxLength: 50 } },
    { name: 'bloodGroup', label: 'Blood Group', type: 'dropdown', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], validations: { required: true, minLength: 10, maxLength: 50 } }
  ]

  referenceChange(event: any) {

    if (this.selectedReference.$ngOptionLabel == "Booking Reference") {
      this.getClientList();
      //show icon to select the existing clients
      this.showClientIcon = true;
    } else {
      //hide existing client selection icon
      this.showClientIcon = false;
      //reset current client infor from the form if "New Customer" is choosen
      this.formGroup.reset();
    }
  }

  changeSourceType(event: any) {
    this.salesService.getSourceNameBySourceType(event).subscribe((source: any) => {

      if (source.result) {
        this.allotmentRelatedData.agentList = source?.result.map((i: any) => {
          i.fullName =
            i?.nameInitial?.name + '. ' + i?.firstName + ' ' + i?.lastName;
          return i;
        });
      }
    })
  }

  private init() {
    setTimeout(() => {
      if (this.allotmentRelatedData?.currentRecord == undefined) {
        this.showClientIcon = false;
        this.formGroup.reset();
        const newCust = referenceList.find((i: any) => i.value == References.newCustomer);
        this.formGroup.get('referenceNumber')?.setValue(newCust);
      } else {
        this.showClientIcon = true;

        const allotmentId = this.route.snapshot.paramMap.get("id");
        if (allotmentId != null || this.allotmentRelatedData?.currentRecord?.action == 'edit') {
          this.getAllotmentById(this.allotmentRelatedData?.currentRecord?.id);
        } else {
          this.currentAllotmentObject = this.allotmentRelatedData?.currentRecord;
          this.setAllotmentDataInForm();
        }
      }
    });
  }

  /**
   * When edit the allotment then set the value using this method.
   */
  setAllotmentDataInForm() {
    if (this.currentAllotmentObject) {
      const ref = referenceList.find((i: any) => i.value == References.bookingRef);
      const currentAllotmentObject = this.currentAllotmentObject;
      setTimeout(() => {
        this.formGroup.get('referenceNumber')?.setValue(ref)
      });
      this.formGroup.get('allotmentDate')?.setValue(new Date())

      if (currentAllotmentObject?.unitDescriptionDetails?.unitCategoryId != undefined) {
        this.formGroup.get('unitDescription')?.setValue(currentAllotmentObject?.unitDescriptionDetails?.id);
        this.selectedUnitCategory = currentAllotmentObject?.unitDescriptionDetails?.unitCategoryId;
        this.filterUnitDescriptionsByCategory(this.selectedUnitCategory);
        this.onChangeUnitDescription(this.selectedUnitCategory);
      }
      const clientObject = currentAllotmentObject?.clientDetail;

      const sourceTypeId = currentAllotmentObject?.sourceDetail?.userSubTypeId;
      this.changeSourceType(sourceTypeId);
      this.formGroup.patchValue({
        id: currentAllotmentObject?.id,
        sourceName: currentAllotmentObject?.sourceDetail?.id,
        sourceType: sourceTypeId,
        firstName: clientObject?.firstName,
        clientId: clientObject?.id,
        lastName: clientObject?.lastName,
        pan: clientObject.panCardNo,
        // uidType: currentAllotmentObject?.uidDocumentSubTypeId,
        aadharNumber: clientObject.aadharNumber,
        nationality: clientObject?.nationality,
        contactNumber: clientObject?.primaryPhoneNo,
        unitCategory: currentAllotmentObject?.unitDescriptionDetails?.unitCategoryId,
        unitDescription: currentAllotmentObject?.unitDescriptionDetails?.name,
        nameInitialsId: clientObject?.nameInitialsId,
        dateOfBirth: clientObject?.dateOfBirth == undefined ? null : new Date(clientObject?.dateOfBirth),
        bookingDate: currentAllotmentObject?.bookingDate == undefined ? null : new Date(currentAllotmentObject?.bookingDate),
        allotmentDate: currentAllotmentObject?.allotmentDate == undefined ? null : new Date(currentAllotmentObject?.allotmentDate),
        weddingAnniversary: clientObject?.weddingAnniversary == undefined ? null : new Date(clientObject?.weddingAnniversary),
        bloodGroup: clientObject?.bloodGroup,
        paymentPlan: currentAllotmentObject?.paymentPlanId,
        email: clientObject?.email,
        gender: clientObject?.gender,
        parentName: clientObject?.fatherHusbandName,
        relationInitialsId: clientObject?.relationInitialsId,
        taxStructure: currentAllotmentObject?.allotmentPaymentDetails == undefined ? null : currentAllotmentObject?.allotmentPaymentDetails[0]?.taxSubtypeId,
      });

      this.currentPaymentScheduledDataRows = currentAllotmentObject?.allotmentPaymentSchedulesDetails == undefined ? null : currentAllotmentObject?.allotmentPaymentSchedulesDetails.map((data: any, index: any) => {
        data.serialNumber = index + 1;
        data["stage"] = data.stageName;
        data["amount"] = data.amount;
        data["date"] = data.dueDate;
        data["action"] = environment.assetsImagePath + IconList.addIconPaymentPlans && environment.assetsImagePath + IconList.DeleteIcon;
        return data;
      });
      this.otherChargesRowData = currentAllotmentObject?.allotmentPaymentDetails == undefined ? null : currentAllotmentObject?.allotmentPaymentDetails.map((data: any, index: any) => {
        data["discount"] = data?.discountAmount;
        data["amount"] = data.amount
        data['totalAmount'] = data.totalAmount
        data["action"] = [{ name: 'edit', popType: 'otherCharges', imgSrc: this.editIcon }, { name: 'delete', popType: 'otherCharges', imgSrc: this.deleteIcon }]

        //if record is being set in edit mode, set basic sale price from allotment record fetched by allotment id
        //it will filter basic sale price from other charges (of basic sale price type) and will fetch price from there so that
        //we set the price which what was selected at the time of allotmet creation, not the current price as it may have been changed
        if (data?.name?.toLowerCase() == 'basic sale price') {
          this.defaultbasicSalePrice = data?.price
        }

        //Set all Discounts applied on any amount type (if any) at the time of allotment creation
        if (currentAllotmentObject?.allotmentDiscountDetails != undefined && currentAllotmentObject?.allotmentDiscountDetails != null) {
          //itrate for each discount in allotment discount list
          var discountList: any[] = []
          currentAllotmentObject?.allotmentDiscountDetails.forEach((disc: any) => {
            //check if current discount is related to current amount sub type then add it to list of current charge
            if (disc?.amountSubTypeId == data?.amountSubTypeId) {
              discountList.push({
                amountSubTypeId: disc?.amountSubTypeId,
                discountRate: disc?.discountRate,
                discountAmount: disc?.amount,
                discountObject: { id: disc?.discountSubTypeId }
              })
            }
          });

          //once all discounts are scanned for current cahrge then set it for current charge
          data["allDiscounts"] = discountList.length > 0 ? discountList : null;
        }
        return data;
      });
    } else {
      const ref = referenceList.find(i => i.value == References.newCustomer);
      this.formGroup.get('referenceNumber')?.setValue(ref)
    }
  }

  /**
 * toggle coomon list for cutomer data modal
 */
  toggleClientList() {
    this.getClientList()
    this.showOverlay = !this.showOverlay;
  }


  /**
 * Gets the client List.
 * @returns {any}
 */
  getClientList() {
    this.salesService.getFilterUser(null, null, UserSubType.Client).subscribe((res: any) => {
      if (res) {
        this.clientList = res?.result.map((i: any) => {
          i.clientName =
            i?.nameInitial?.name + '. ' + i?.firstName + ' ' + i?.lastName;
          return i;
        });
      }
    });
  }


  /**
* Set the value of formControls of child component/common component.
* @param {any} data
*/
  setSelecetedCustomer(data: any) {
    // set values to form controls
    if (data) {
      this.formGroup.get('firstName')?.setValue(data[0]?.firstName)
      this.formGroup.get('lastName')?.setValue(data[0]?.lastName)
      this.formGroup.get('contactNumber')?.setValue(data[0]?.primaryPhoneNo)
      this.formGroup.get('nameInitialsId')?.setValue(data[0]?.nameInitial?.id)
      this.formGroup.get('pan')?.setValue(data[0]?.panCardNo)
      this.formGroup.get('relationInitialsId')?.setValue(data[0]?.relationInitial?.id)
      this.formGroup.get('parentName')?.setValue(data[0]?.fatherHusbandName)
      this.formGroup.get('clientId')?.setValue(data[0]?.id)
      this.formGroup.get('gender')?.setValue(data[0]?.gender)
      this.formGroup.get('crmRefLeadId')?.setValue(data[0]?.id)

      this.formGroup.get('email')?.setValue(data[0]?.email)
      this.showOverlay = false;
    }
  }

  getGenders() {
    this.genders = this.commonService.getGenders().result;
  }

  getUIDTypeList() {
    const uidDocument = this.allotmentRelatedData?.documentTypeList.filter((doc: any) => doc?.name === 'UID');
    let uidObject = null;

    if (uidDocument.length === 0) {
      uidObject = (uidDocument == undefined) ? null : (uidDocument[0]?.documentSubTypes.filter((doc: any) => doc?.id != DocumentSubType.AadhaarBack
        && doc?.id != DocumentSubType.VoterIdBack));

      const aadhaarFrontIndex = uidObject.findIndex((doc: any) => doc?.id === DocumentSubType?.AadhaarFront);
      uidObject[aadhaarFrontIndex].name = "Aadhar";
      this.uidTypeList = uidObject;
    }
  }

  //pan validator
  get pan() {
    return this.formGroup.get('pan');
  }

  //email validator
  get email() {
    return this.formGroup.get('email');
  }

  //event used to validate length of contact number on keyPress
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onChangeUnitCategory(currentUnit: any) {
    this.selectedUnitCategory = this.selectedUnitCategory;
    this.selectedUnitDescription = null;
    this.otherChargesRowData = null;
    this.currentPaymentScheduledDataRows = [];
    this.selectedPaymentPlan = null;
    this.mandatoryAmountSubType = [];

    //reset basic sale price as it will be set based on selected unit descriotion & payment plan
    this.defaultbasicSalePrice = 0.00

    this.resetValue();
    // this.formGroup.controls["taxStructure"].setValue(null);
    this.formGroup.controls["paymentPlan"].setValue(null);
    if (this.selectedUnitCategory) {
      this.filterUnitDescriptionsByCategory(this.selectedUnitCategory);
      //before setting up the basic sale price and charges detailes we need to set amount sub type based on selected unit category
      //Since we are resetting payment plan on change of unit category hence no point to filter the amount sub type
      // this.eligibleAmountSubTypeList = this.filterAmountSubTypeList()
      // this.mandatoryAmountSubType = this.filterAmountSubTypeList(true)
    } else {
      this.filteredUnitDescriptions = [];
    }
  }

  onChangeUnitDescription(eve: any) {
    this.isDisabledCharges = false;
    const unitCategoryObj = this.getUnitCategoryObj()
    if (unitCategoryObj) {
      this.currentUnitCategoryObj = unitCategoryObj;
      this.salesService.emitAllotmentBasicDetailData(this.currentUnitCategoryObj);
    } else {
      this.currentUnitCategoryObj = [];
    }

    //if payment plan is selected then only calculate the amount /charges on unit selection/change
    if (this.selectedPaymentPlan > 0 && this.selectedPaymentPlan != null && this.selectedPaymentPlan != undefined)
      this.calculateCharges()
  }

  /**
   * Calculates the charges based on selected unit category and description and payment plan
   */
  calculateCharges() {
    if (this.selectedUnitCategory) {
      let unitCategoryObj = this.getUnitCategoryObj()
      const basicSalePrice = this.mandatoryAmountSubType?.find((data: any) =>
        data.name === AmountSubTypes.BasicSalePrice)?.amount ?? null;

      if (this.bookingId != null && this.allotmentRelatedData?.currentRecord === undefined) {
        this.defaultbasicSalePrice = basicSalePrice;
      } else if (this.allotmentRelatedData?.currentRecord?.id) {
        this.defaultbasicSalePrice = basicSalePrice;
      } else if (this.allotmentRelatedData?.currentRecord == undefined) {
        this.defaultbasicSalePrice = basicSalePrice;
      } else {
        this.defaultbasicSalePrice = this.allotmentRelatedData?.currentRecord?.basicSalePrice ?? null;
      }

      this.otherChargeForm.patchValue({ amountRate: this.defaultbasicSalePrice, superArea: unitCategoryObj?.superArea });
      this.addOtherChargesRow();
    }
  }

  /**
   * Filters the amount sub type to decide payment details of allotment based on selected unit category and payment plan
   */
  filterAmountSubTypeList(mandatoryCharges?: any) {
    var tempAmountSubTypes = []

    if (this.selectedUnitCategory && this.selectedUnitCategory != 0) {
      //get the unit category object based on seletced unit category
      const unitCategoryObj = this.allotmentRelatedData?.unitCategoryList.find((i: any) => i.id === this.selectedUnitCategory)

      //if unit category object exists then filter amount sub type list based on unit category's unit sub type id
      if (unitCategoryObj) {
        //first filter amount sub type based on unit category's unit sub type 
        tempAmountSubTypes = this.allotmentRelatedData.amountSubTypesAgainstProject.filter((as: any) =>
          as.unitSubTypeId == unitCategoryObj?.unitSubType?.id || as.unitSubTypeId == undefined ||
          as.unitSubTypeId == null
        )

        //Now we have to filter the already filtered amount sub type list based on selected payment plan if selected
        if (this.selectedPaymentPlan > 0) {
          tempAmountSubTypes = tempAmountSubTypes.filter((as: any) =>
            as.paymentPlanId == this.selectedPaymentPlan || as.paymentPlanId == undefined || as.paymentPlanId == null
          )
        }
      }
    }
    //This the case when unit category is not selected and payment plan is selected then filter amount sub type
    //based on selected payment plan but from amount sub type list applicable for that project
    else if (this.selectedPaymentPlan && this.selectedPaymentPlan != 0 && this.selectedPaymentPlan != undefined) {
      tempAmountSubTypes = this.allotmentRelatedData.amountSubTypesAgainstProject.filter((as: any) =>
        (as.paymentPlanId == this.selectedPaymentPlan || as.paymentPlanId == undefined || as.paymentPlanId == null)
        && as.isMandatory == mandatoryCharges
      )
    }

    //if need to get only mandatory or non-mandatory amount subtype. otherwise all eligible amount sub type will be returned
    if (mandatoryCharges) {
      tempAmountSubTypes = tempAmountSubTypes.filter((as: any) => as.isMandatory == mandatoryCharges)
    }
    // else {
    //   //When we need to select all cahrges and unit category or payment plans are not selected
    //   //this would specially be case for non-manadatory cahrges
    //   tempAmountSubTypes = this.allotmentRelatedData.amountSubTypesAgainstProject.filter((as: any) =>
    //     as.isMandatory == mandatoryCharges
    //   )
    // }
    return tempAmountSubTypes;
  }

  onChangeTaxStructure() {
    if (this.selectedTaxName) {
      // this.addOtherChargesRow();
      // delete this.formGroup.controls['uidNumber'];
      // delete this.formGroup.controls['uidType'];

      const formdata = this.formGroup.value;
      if (formdata?.paymentPlan) {
        this.onChangePaymentPlan(formdata?.paymentPlan);
      }
    }
  }


  getRoleList() {
    this.roleListData = this.jwtService.currentUserRolesValue
  }

  getEligibleDiscounts(amountSubTypeId: any) {
    // this.selectedOtherChargesHead = 0;
    this.eligibleDiscountList = []
    //clear existing discount control array
    this.clearDiscounts()

    var rowToEdit: any = this.selectedRowDataToEdit
    //since discount is applicable on a particular amount sub type hence it must have value
    if (amountSubTypeId != null && amountSubTypeId != undefined && amountSubTypeId != "") {
      //check if this amount subType has any applicable discount on it. If yes then check if current user has the approval role for the discount
      this.salesService.filterDiscountSubTypeList(null, null, null, amountSubTypeId).subscribe(data => {
        if (data?.result) {
          this.discountSubTypeList = data?.result;
          //There may be multiple discounts on same amount sub type liek firm discount/director discount etc
          //We need to check all approvar roles in all applicable discounts on that amount sub type
          // discountRoleObject = this.commonService.getUniqueValuesFromJsonArray(this.discountSubTypeList, 'approverRoleDetails?.name')
          this.discountSubTypeList.forEach((discount: any) => {
            var approvalRole = this.roleListData.find((role: any) => role == discount?.approverRoleDetails?.name)
            if (approvalRole != null && approvalRole != undefined) {
              //we need to check if current row being edited, has this discount amount set earlier or not 
              //if yes then we need to set the same amount which was set ealier to this to display on popup modal.

              //check if current row being edit already has any discount set ealier or not 
              if (rowToEdit?.allDiscounts != undefined && rowToEdit?.allDiscounts?.length > 0)
                var existingDiscount = rowToEdit?.allDiscounts.find((cd: any) => cd.discountObject?.id == discount?.id)

              //check if current discount sub tye id exist in current row or not
              if (existingDiscount != undefined) {
                discount.discountRate = existingDiscount?.discountRate
                discount.discountAmount = existingDiscount?.discountAmount
                // this.addDiscountToAmountSubType({
                //   'discountRate': existingDiscount?.discountRate,
                //   'discountAmount': existingDiscount?.discountAmount,
                //   'maxDiscount': existingDiscount.maxDiscount,
                // })
              }
              // else
              this.eligibleDiscountList.push(discount)
              this.addDiscountToAmountSubType(discount)
            }
          });
        }
        //check if current user has the role for the discount 
        //   if (this.eligibleDiscountList && this.eligibleDiscountList.length > 0) {
        //     // Ensure roleList is always an array

        //     // const discountData = this.discountSubTypeList[0];
        //     // let discoutsubTypeObject = discountData?.discountSubTypes?.filter((data: any) => data?.amountSubtypeId == amountSubtypeId);

        //     this.isAuthForDiscount = true;
        //     this.otherChargeForm.get('discount')?.enable();
        //     this.discoutsubTypeObject = discoutsubTypeObject[0];
        //     this.maxDiscount = discoutsubTypeObject[0]?.maxDiscount;
        //   }
        //   else {
        //     this.isAuthForDiscount = false;
        //     this.otherChargeForm.get('discount')?.disable();
        //     this.maxDiscount = 0.0;
        //   }

        //   let amount = 0.0;
        //   let selectedOtherChargesHead = this.nonMandatoryOtherCharges.filter((data: any) => data.id == amountSubtypeId)[0];

        //   if (selectedOtherChargesHead?.amountFrequency == "Amount") {
        //     if (selectedOtherChargesHead?.amountUnit == "Per Unit") {
        //       amount = selectedOtherChargesHead?.amount * Number(this.receivedBasicDetailsData?.superArea)
        //     } else {
        //       amount = selectedOtherChargesHead?.amount;
        //     }
        //   } else {
        //     const basicObject = this.defaultotherChargesData.filter((data: any) => data.name == AmountSubTypes.BasicSalePrice)
        //     const totalValue = basicObject[0]?.amount * Number(this.receivedBasicDetailsData?.superArea);
        //     amount = (totalValue * selectedOtherChargesHead?.amount) / 100;
        //   }
        //   amount = amount);
        //   this.selectedOtherChargesHead = amount;
        //   this.otherChargeForm.patchValue({ basicSalePrice: amount })
        // }
      });
    }
  }

  getOtherChargesData(): any {
    return this.otherChargesRowData; // Replace this with actual live data fetching logic
  }

  discountChange(currentDiscount: any, index: any) {
    let discount = currentDiscount?.value?.discountRate;

    // Validate discount against max discount
    if (discount > currentDiscount.value?.maxDiscount) {
      this.toastr.error(`Discount amount cannot exceed the max discount (₹ ${currentDiscount?.value?.maxDiscount}/-)`);
      //we need to reset the dicosunt to previous state if it was added earlier. if not then set to 0
      var previousDiscount = this.selectedRowDataToEdit?.allDiscounts?.find((dis: any) =>
        dis.discountObject?.id == currentDiscount?.value?.discountObject?.id)
      if (previousDiscount != null && previousDiscount != undefined) {
        currentDiscount.controls["discountRate"].patchValue(previousDiscount?.discountRate);
        discount = previousDiscount?.discountRate
      }
      else {
        currentDiscount.controls["discountRate"].patchValue(0);
        discount = 0.0;
      }
    }

    //get super area or unit to calculate current discount amount (if based on per unit)
    const disObject = currentDiscount?.value?.discountObject;
    const superArea = Number(this.receivedBasicDetailsData?.superArea);

    // Calculate discount amount based on discount type
    let discountAmount = 0.0;
    if (disObject.discountFrequency === "Amount") {
      discountAmount = disObject.discountUnit === "Per Unit" ? discount * superArea : discount;
    } else {
      const basicObject = this.eligibleAmountSubTypeList.find((data: any) => data.id === AmountSubTypes.BasicSalePrice);
      const totalValue = basicObject?.amount * superArea;
      discountAmount = (totalValue * disObject?.amount) / 100;
    }

    //Set the current discount amount in form cntrol
    this.discounts.controls[index].value.discountAmount = discountAmount ?? 0
    currentDiscount.controls["discountAmount"].patchValue(discountAmount);

    //calcuate total of all discount (in case if there are multiple discounts) 
    //as on change of current discount will add discountAmount of other discounts with discountAmount of current discount
    //and total discount value will be deducted from total amount so that tax can be calculated on taxable amount only
    var totalDiscountAmount = 0;
    this.discounts.controls.forEach((currDisc: any) => {
      totalDiscountAmount = totalDiscountAmount + (this.commonService.isNullUndefined(currDisc?.value?.discountAmount) ? 0 : currDisc?.value?.discountAmount)
    })

    this.discountValue = totalDiscountAmount
    //Set total discount amount on the form
    this.otherChargeForm.controls['discount'].patchValue(totalDiscountAmount)

    //reset discount value as user may cancel to set discount. It should get recalculated

    // Update discount value and taxable amount
    this.selectedRowDataToEdit.discount = totalDiscountAmount
    const amountAfterDiscount = this.selectedOtherChargesHead - totalDiscountAmount;
    this.taxableAmount = Math.max(amountAfterDiscount, 0); // Ensure taxable amount is not negative

    // Trigger tax recalculation
    this.otherTaxChange(this.otherChargeForm?.value?.otherTaxType);
  }


  /**
   * Add a new discount object to a particular amount sub type on other charged edit popup
   * @param discount 
   * @returns 
   */
  newDiscount(discount: any = null): FormGroup {
    return this.fb.group({
      discountObject: [discount],
      discountRate: [discount?.discountRate],// [discount?.amount != null && discount?.amount != undefined ? discount?.amount : 0],
      discountAmount: [discount?.discountAmount],// [discount?.amount != null && discount?.amount != undefined ? discount?.amount : 0],
      maxDiscount: [discount?.maxDiscount]
    });
  }

  /**
   * Get All Discounts of an amount sub type
   */
  get discounts(): FormArray {
    return this.otherChargeForm.get("allDiscounts") as FormArray;
  }

  /**
   * Add discount to discount array of an amount sub type 
   */
  addDiscountToAmountSubType(discountData: any) {
    this.discounts.push(this.newDiscount(discountData));
  }

  clearDiscounts() {
    this.discounts.controls = [];
  }

  filterUnitDescriptionsByCategory(unitCategoryId: number) {
    this.filteredUnitDescriptions = this.allotmentRelatedData?.unitDescriptionList.filter(
      (desc: any) => desc.unitCategoryId === unitCategoryId && desc.isAllotted == false
    );

    this.selectedUnitDescription = null;
  }

  onChangePaymentPlan(currentPaymentPlan: any) {
    //if allotment is getting created from booking then payment plan will be same as it was decided at time of booking because
    //due to payment plan change amount will be changed too. 
    if (this.salesService?.currentBooking) {
      this.selectedPaymentPlan = this.salesService?.currentBooking?.paymentPlanDetail?.name
    } else {
      this.selectedPaymentPlan = currentPaymentPlan;
    }

    //make sure any payment plan is selected
    if (currentPaymentPlan != null && currentPaymentPlan != -1 && currentPaymentPlan != undefined) {

      if (!this.selectedUnitDescription || this.selectedUnitDescription == null || this.selectedUnitDescription == undefined) {
        alert("Please select the unit first")
        this.formGroup.controls["paymentPlan"].setValue(null);
        this.selectedPaymentPlan = null;
      }
      else {
        //filter the amount sub type based on selected payment plan
        this.eligibleAmountSubTypeList = this.filterAmountSubTypeList()
        this.mandatoryAmountSubType = this.filterAmountSubTypeList(true)
        this.calculateCharges()
        if (this.bookingDate)
          this.validationAndCreatePaymentScheduleData(currentPaymentPlan, this.defaultbasicSalePrice, this.receivedBasicDetailsData, this.bookingDate);
      }
    }
    else {
      //if payment plan is not selected set payment schedule to null
      this.currentPaymentScheduledDataRows = []
      this.defaultbasicSalePrice = 0
    }
  }

  private validationAndCreatePaymentScheduleData(paymentPlanId: any, saleRate: any, receivedBasicDetailsData: any, bookingDate: any) {
    if (this.allotmentRelatedData?.paymentPlanList?.find((i: any) => i.id === paymentPlanId)
      && saleRate && !isNaN(saleRate)
      && this.allotmentRelatedData?.unitCategoryList.find((i: any) => i.id === receivedBasicDetailsData?.id)) {
      this.currentPaymentScheduledDataRows = this.createPaymentScheduleData(this.allotmentRelatedData?.paymentPlanList?.find((i: any) => i.id === paymentPlanId), bookingDate);
    } else {
      this.currentPaymentScheduledDataRows = [];
    }
  }

  createPaymentScheduleData(selectedPaymentPlan: any, bookingDate: any) {
    const dataRows: any = [];
    this.currentPaymentScheduledDataRows = [];
    var datePipe = new DatePipe('en-US');
    if (selectedPaymentPlan?.paymentStages?.length) {
      let lastDate = new Date(bookingDate);
      let totalValue = this.calculateTotal();
      selectedPaymentPlan.paymentStages.forEach((stage: any, index: any) => {
        const paymentStage: any = {};
        paymentStage.serialNumber = index + 1;
        paymentStage.stage = stage.amountPercentage;
        paymentStage.amount = ((totalValue * stage?.amountPercentage) / 100);

        let date = datePipe.transform(this.addDays(lastDate, stage?.dueInDays), 'dd-MMM-yyyy');
        paymentStage.date = date;
        paymentStage.action = environment.assetsImagePath + IconList.addIconPaymentPlans && environment.assetsImagePath + IconList.DeleteIcon;

        dataRows.push(paymentStage);
      });
    }
    return dataRows;
  }

  calculateTotal(): number {
    let total = this.otherChargesRowData.reduce((data: any, currentValue: any) => data + parseFloat(currentValue.totalAmount), 0);
    return total
  }

  addOtherChargesRow() {
    if (!this.selectedUnitCategory) {
      this.otherChargesRowData = []; // Clear the table if prerequisites aren't met
      return;
    }
    const selectedTax = this.allotmentRelatedData?.taxSubTypeList.find((tax: any) => tax.id === this.selectedTaxName);
    var taxRate = selectedTax == null ? 0 : parseFloat(selectedTax.taxPercentageValue);
    const dividedRate = taxRate / 2; // Split equally for CGST and SGST

    //Filter charges on the behalf of unit descriptions
    const unitDescriptionId = this.formGroup?.value?.unitDescription;

    const unitDescriptionObject = this.filteredUnitDescriptions.filter((data: any) => data.id == unitDescriptionId);
    let amountSubTypesAgainstProject = this.mandatoryAmountSubType;

    if (!unitDescriptionObject[0]?.isParkFacing) {
      amountSubTypesAgainstProject = amountSubTypesAgainstProject.filter((item: any) =>
        item?.name != AmountSubTypes.ParkPLC);
    }

    if (!unitDescriptionObject[0]?.isCorner) {
      amountSubTypesAgainstProject = amountSubTypesAgainstProject.filter((item: any) =>
        item?.name != AmountSubTypes.CornerPLC);
    }

    if (!unitDescriptionObject[0]?.isWideRoad) {
      amountSubTypesAgainstProject = amountSubTypesAgainstProject.filter((item: any) =>
        item?.name != AmountSubTypes.WideRoadPLC);
    }

    if (this.allotmentRelatedData?.currentRecord?.previousBookingId != null) {
      this.showClientIcon = false;
      this.mandatoryAmountSubType.map((item: any) => {
        if (item?.name == AmountSubTypes.BasicSalePrice) {
          item.amount = this.defaultbasicSalePrice;
        }
        return item;
      });
    }

    this.otherChargesRowData = this.mandatoryAmountSubType.map((data: any) => {
      let amountRate = data?.amount
      let amount = 0
      let grossAmount: any = 0.0;//data?.amount * Number(this.receivedBasicDetailsData?.superArea);

      if (data.amountFrequency == "Amount") {
        if (data.amountUnit == "Per Unit") {
          amount = (amountRate * Number(this.receivedBasicDetailsData?.superArea))
        } else {
          amount = amountRate;
        }
      } else {
        const basicObject: any = this.mandatoryAmountSubType.filter((data: any) => data?.name == AmountSubTypes.BasicSalePrice);
        const totalValue: any = (basicObject[0]?.amount * Number(this.receivedBasicDetailsData?.superArea));
        amount = ((totalValue * data?.amount) / 100);
      }

      let discount = 0.0;
      let taxableAmount: any = (amount - this.discountValue);
      let cgst: any = ((dividedRate / 100) * amount);
      let sgst: any = ((dividedRate / 100) * amount);
      let igst: any = 0.0;
      let taxAmount = cgst + sgst
      let totalAmount: any = (taxableAmount + taxAmount);

      //format amount to be comma separated
      return {
        ...data,
        amountRate,
        amount,
        discount,
        taxableAmount,
        cgst,
        sgst,
        igst,
        taxAmount,
        totalAmount,
        dividedRate,
        selectedTax,
        action: [{ name: 'edit', popType: 'otherCharges', imgSrc: this.editIcon }, { name: 'delete', popType: 'otherCharges', imgSrc: this.deleteIcon }]
      }
    })
  }

  onChangeOtherChargesHead(id: any) {
    //reset current values of other charges form
    this.resetValue();

    //check if this charges is already added in the list, then it must not re-added
    const isExist = this.otherChargesRowData.filter((data: any) => data.id == id);
    const amountTypeData = this.allotmentRelatedData.amountSubTypesAgainstProject.filter((data: any) => data.id == id)[0];
    if (isExist?.length > 0) {
      this.toastr.error("This charges is already applied,Plese select another charge!");
      this.isSubmitDisabled = true;
      return;
    }

    //#region Validation Applicable Charges
    //Now check if this charge is applicable for selected unit or not
    const unitDescriptionId = this.formGroup?.value?.unitDescription;

    const unitDescriptionObject = this.filteredUnitDescriptions.filter((data: any) => data.id == unitDescriptionId);

    if (!unitDescriptionObject[0]?.isParkFacing && AmountSubTypes.ParkPLC == amountTypeData.name) {
      this.toastr.error("This park PLC is not applicable for this unit!");
      this.isSubmitDisabled = true;
      return;
    }

    if (!unitDescriptionObject[0]?.isCorner && AmountSubTypes.CornerPLC == amountTypeData.name) {
      this.toastr.error("This corner PLC is not applicable for this unit!");
      this.isSubmitDisabled = true;
      return;
    }

    if (!unitDescriptionObject[0]?.isWideRoad && AmountSubTypes.WideRoadPLC == amountTypeData.name) {
      this.toastr.error("This wide road PLC is not applicable for this unit!");
      this.isSubmitDisabled = true;
      return;
    }
    this.isSubmitDisabled = false;
    //#endregion

    //Get discount if applicable
    this.getEligibleDiscounts(id);

    //set the amountRate based on selected amount sub type
    this.selectedOtherChargeAmountRate = amountTypeData?.amount;

    //calculate other charges based on selected other charges head and type of amount/percentage, unit of amount(unit/full) rtc.
    // this.onOtherChargeAmountRateChange(this.selectedOtherChargeAmountRate);
  }

  /**
   * Calculate the payment schedule based on selected date and payment plan
   * @param bookingDate Booking date selected in booking calendar
   */
  onChangeBookingDate(bookingDate: any) {
    if (this.allotmentDate != null && this.allotmentDate != undefined) {
      if (this.bookingDate > this.allotmentDate) {
        alert('Booking date can not be after allotment date');
        this.bookingDate = new Date();
      }
      else {
        this.validationAndCreatePaymentScheduleData(this.selectedPaymentPlan, this.defaultbasicSalePrice, this.receivedBasicDetailsData, bookingDate)
      }
    }
    else {
      //if allotment date is not selected but booking date is selected then also payment schedule can be created
      this.validationAndCreatePaymentScheduleData(this.selectedPaymentPlan, this.defaultbasicSalePrice, this.receivedBasicDetailsData, bookingDate)
    }
  }

  /**
   * Triggers the allotment date change event to validate allotment date is not prior to booking date
   * @param allotmentDate Allotment date selected in allotment calendar
   */
  onChangeAllotmentDate(allotmentDate: any) {
    if (this.bookingDate != null && this.bookingDate != undefined) {
      if (this.bookingDate > allotmentDate) {
        alert('Allotment date can not be before booking date');
        this.allotmentDate = new Date();
      }
    }
    else {
      //if booking date not selected and allotment date is selected then set the booking date same as allotment date by default
      //and create the payment schedule
      this.bookingDate = allotmentDate;
      this.validationAndCreatePaymentScheduleData(this.selectedPaymentPlan, this.defaultbasicSalePrice, this.receivedBasicDetailsData, this.bookingDate)
    }
  }

  getAllotmentById(allotmentId: any) {
    this.salesService.getAllotmentById(allotmentId).subscribe((response: any) => {
      this.currentAllotmentObject = response?.result;
      this.setAllotmentDataInForm();
    });
  }


  /**
   * Submit the Form to save the data
   * @returns 
   */
  submit() {
    this.Submitted = true;
    //mark that we are submitting the form
    this.isSubmitting = true;

    if (this.formGroup.invalid) {
      return;
    }
    const editRecord = this.allotmentRelatedData.currentRecord;
    let formdata = this.formGroup.value;
    const currentProject = JSON.parse((localStorage.getItem('selectedProject') as any));

    let submitObject = {
      projectId: currentProject.id,
      crmRefLeadId: formdata?.referenceNumber?.value == "newCustomer" ? null : formdata?.crmRefLeadId,
      clientId: (formdata?.clientId == undefined || formdata?.clientId == null) ? 0 : formdata?.clientId,
      previousBookingId: (this.bookingId != null && this.allotmentRelatedData?.currentRecord == undefined) ? null : this.allotmentRelatedData?.currentRecord?.previousBookingId,
      bookingRefClientId: null,
      sourceId: formdata?.sourceName,
      allotmentDate: formdata?.allotmentDate,
      bookingDate: formdata?.bookingDate,
      paymentPlanId: formdata?.paymentPlan,
      isActive: true,
      unitDescriptionId: formdata?.unitDescription,
      clientDetail: (editRecord?.id) ? (this.clientDetails(formdata, editRecord)) : this.clientDetails(formdata),
      paymentSchedule: this.PaymentScheduleData(this.currentPaymentScheduledDataRows, formdata?.paymentPlan),
      allotmentOtherCharges: this.OtherChargeList()
    }

    if (editRecord?.id > 0) {
      this.salesService.putAllotmentData(submitObject, editRecord?.id).subscribe({
        next: (result: any) => {
          this.toastr.success("Allotment updated successfully.");
        },
        error: (error) => {
          this.toastr.error("Error while updating allotment.");
        },
        complete: () => {
          this.isSubmitting = false; // re-enable the button regardless of success/failure
        }
      });
    } else {
      this.salesService.postAllotmentData(submitObject).subscribe({
        next: (result: any) => {
          this.toastr.success("Allotment created successfully.");
        },
        error: (error) => {
          this.toastr.error("Error while creating allotment.");
        },
        complete: () => {
          this.isSubmitting = false; // re-enable the button regardless of success/failure
        }
      });
    }
  }

  PaymentScheduleData(data: any, paymentPlanId: any) {
    const paymentPlan = this.allotmentRelatedData?.paymentPlanList.filter((data: any) => data.id == paymentPlanId)[0];
    const result = data.map((item: any) => ({
      id: item?.id == undefined ? null : item?.id,
      allotmentId: item?.allotmentId == undefined ? null : item?.allotmentId,
      stageId: paymentPlan?.paymentStages[item?.serialNumber - 1]?.id,
      stageName: paymentPlan?.paymentStages[item?.serialNumber - 1]?.name,
      amount: item?.amount,
      dueDate: this.commonService.dateTimeFormate(item?.date),
      isActive: true,
    }));
    return result;
  }

  clientDetails(data?: any, editRecord?: any) {
    let uidDetails = {};
    let panDetails = {}
    let panDocId = null;
    let uidDocId = null;

    panDetails = {
      documentId: panDocId,
      documentNumber: data?.pan,
      documentSubTypeId: DocumentSubType.Pan,
      isActive: true,
      isVerified: false,
      document: null
    }
    uidDetails = {
      documentId: uidDocId,
      documentNumber: this.formGroup.controls['aadharNumber'].value,
      documentSubTypeId: DocumentSubType?.AadhaarFront,
      isActive: true,
      isVerified: false,
      document: null
    }

    if (editRecord) {
      panDocId = editRecord?.clientDetails?.documentList.filter((data: any) => data.documentSubTypeId == DocumentSubType.Pan)[0]?.documentId;
      const uidObject = editRecord?.clientDetails?.documentList.filter((data: any) => data.documentSubTypeId == data?.uidType);
      if (uidObject && uidObject[0]?.documentSubTypeId == data?.uidType) {
        uidDocId = uidObject[0]?.documentId
      }
    }
    const ClientDetails = {
      id: editRecord?.clientId == undefined ? null : editRecord?.clientId,
      nameInitialsId: data?.nameInitialsId,
      firstName: data?.firstName,
      lastName: data?.lastName,
      relationInitialsId: data?.relationInitialsId,
      fatherHusbandName: data?.parentName,
      gender: data?.gender,
      bloodGroup: data?.bloodGroup,
      nationality: data?.nationality,
      email: data?.email,
      primaryPhoneNo: data?.contactNumber,
      secondaryPhoneNo: data?.secondaryPhoneNo,
      dateOfBirth: data?.dateOfBirth,
      weddingAnniversary: data?.weddingAnniversary,
      Documents: (data?.aadharNumber == null || data?.aadharNumber == "") ? [panDetails, uidDetails] : [panDetails, uidDetails]
    };


    return ClientDetails;
  }

  //This method is used for create object for allotment other charge data when saving or updating the allotment
  OtherChargeList() {
    const result = this.otherChargesRowData.map((item: any) => ({
      id: item?.amountSubTypeId == undefined ? null : item?.id,
      amountSubTypeId: item?.amountSubTypeId == undefined ? item?.id : item?.amountSubTypeId,
      taxSubtypeId: item?.taxSubtypeId == undefined ? item.selectedTax?.id || null : item?.taxSubtypeId,
      price: item?.amountRate,
      amount: item?.amount,
      cgst: item?.cgst,
      sgst: item?.sgst,
      igst: item?.igst,
      discountAmount: item?.discount,
      netAmount: item?.totalAmount,
      discountList: (item?.allDiscounts != undefined && item?.allDiscounts != null) ? this.prepareAllotmentDiscountList(item?.allDiscounts) : null,
      discountSubTypeId: item?.discountSubTypeId || null,
      isActive: true
    }));
    return result;
  }

  /**
   * Prepares the allotment discount array
   * @param discountList list of allotment discounts selected on screen
   * @returns returns list of allotment discounts who has values
   */
  prepareAllotmentDiscountList(discountList: any) {
    let discounts: any[] = []
    discountList.forEach((disc: any) => {
      if (disc?.discountAmount != null && disc?.discountAmount > 0)
        discounts.push({
          //if record is creating first time then allotment id will not be there it will be fetched at server after
          //creating allotment record in allotments table
          allotmentId: this.allotmentRelatedData.currentRecord?.id != null ? this.allotmentRelatedData.currentRecord?.id : null,
          AmountSubTypeId: disc?.discountObject?.amountSubtypeId,
          discountSubTypeId: disc?.discountObject?.id,
          discountRate: disc?.discountRate,
          amount: disc?.discountAmount
          //approved by details need to be send, we need to create screen for selecting approvar as
          //data entry can be done by operation team while discount was approved by management
          //approvedBy: null,
          //approvedOn: <approval Date has to be selected from screen
        })
    });

    return discounts?.length > 0 ? discounts : null;
  }

  isMultipleChange() {

  }

  /**
   * Submit data of Other Charge edit popup modal to update the other charges in table
   * @returns returns current charge modifed object (discount may be added or removed or new charge may be added)
   */
  submitOtherChargesData() {
    this.OtherFormSubmitted = true;
    if (this.otherChargeForm.invalid) {
      return;
    }
    let otherCharge = this.otherChargeForm.value;
    let discount = this.discoutsubTypeObject;

    if (this.isEditOtherRow) {
      const selectedAmountType = this.otherChargesRowData.filter((data: any) => data.id == otherCharge?.amountSubType)[0];

      const index = this.otherChargesRowData.findIndex((item: any) => item.id == otherCharge?.amountSubType);
      if (index !== -1) {
        // Update the object at the found index
        const formObject = this.otherChargeForm.value;
        selectedAmountType.amount = selectedAmountType?.amount;
        selectedAmountType.cgst = formObject?.cgst;
        selectedAmountType.igst = this.igstValue;
        selectedAmountType.igstRate = formObject?.igstRate;
        selectedAmountType.sgst = this.sgstValue;
        selectedAmountType.taxableAmount = this.taxableAmount;
        selectedAmountType.totalAmount = this.totalAmount;
        selectedAmountType.discount = formObject?.discount;

        //add discount only if applied otherwise not
        var discountList = this.getappliedDiscounts(formObject.allDiscounts)
        selectedAmountType.allDiscounts = discountList != null ? discountList : null

        if (selectedAmountType?.selectedTax)
          selectedAmountType.selectedTax.id = formObject?.otherTaxType;

        selectedAmountType.discountSubTypeId = discount?.id || null;
        this.otherChargesRowData[index] = { ...this.otherChargesRowData[index], ...selectedAmountType };
        // //just  update object so that it can trigger on change event and charges table can be updated
        this.otherChargesRowData = [...this.otherChargesRowData]
      }
    } else {
      const selectedAmountType = this.nonMandatoryOtherCharges.filter((data: any) => data.id == otherCharge?.amountSubType);
      let newOtherObject = {
        id: selectedAmountType[0]?.id,
        discountSubTypeId: discount?.id || null,
        name: selectedAmountType[0]?.name,
        amount: selectedAmountType[0]?.amount,
        cgst: this.cgstValue,
        discount: this.discountValue,
        sgst: this.sgstValue,
        igst: this.igstValue,
        roundOff: this.roundOffGrossAmount,
        totalAmount: this.roundOffGrossAmount,
        selectedTax: {
          id: otherCharge?.otherTaxType
        },
        action: [{ name: 'edit', popType: 'otherCharges', imgSrc: this.editIcon }, { name: 'delete', popType: 'otherCharges', imgSrc: this.deleteIcon }]
      };
      this.otherChargesRowData = [...this.otherChargesRowData, newOtherObject];
    }

    if (this.bookingDate != null && this.bookingDate != undefined && isDateValid(this.bookingDate))
      this.validationAndCreatePaymentScheduleData(this.selectedPaymentPlan, this.defaultbasicSalePrice, this.receivedBasicDetailsData, this.bookingDate);

    this.showOtherChargesModal = false;
  }

  /**
   * Filters only those discounts which were applied on current allotment out of all eligible discounts
   * @param discountList All eligible discount list
   * @returns returns on applied discount List
   */
  getappliedDiscounts(discountList: any[]) {
    var list: any[] = []
    discountList.forEach((discount: any) => {
      if (discount?.discountAmount > 0)
        list.push(discount)
    })

    return list.length > 0 ? list : null;
  }

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls
  }

  get fo(): { [key: string]: AbstractControl } {
    return this.otherChargeForm.controls
  }

  addDays(date: Date, days: number) {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return new Date(newDate);
  }

  additionalDetails(formType: string) {
    this.formDataConfig = undefined;
    this.showDetailedModal = false;
    //@ts-ignore
    this.formIdentity = FormIdentity[formType];
    switch (this.formIdentity) {
      case FormIdentity.coApplicantDetails:
        this.formDataConfig = this.coApplicantDetailsConfig;
        break;
      case FormIdentity.familyMemberDetails:
        this.formDataConfig = this.familyMemberDetailsConfig;
        break;
      case FormIdentity.nomineeMemberDetails:
        this.formDataConfig = this.nomineeDetailsConfig;
        break;
    }
    this.showDetailedModal = true;

    this.cdr.markForCheck();
  }

  onCommonFormSubmit(formInfo: IFormInfo) {
    if (formInfo) {
      switch (formInfo.formIdentity) {
        case FormIdentity.coApplicantDetails:
          this.coApplicantColumnDefs = coApplicantColDefs;
          if (Array.isArray(formInfo.formData)) {
            this.coAppRowData = formInfo.formData;
          } else {
            let arr: any = [];
            const obj: any = {};
            Object.keys(formInfo.formData).forEach((key, index) => {
              obj[key] = formInfo.formData[key];
            });
            obj["action"] = [{ name: 'edit', popType: 'coApplicant', imgSrc: this.editIcon }, { name: 'delete', popType: 'coApplicant', imgSrc: this.deleteIcon }]
            arr.push(obj);

            this.coAppRowData = arr;
          }
          break;
        case FormIdentity.familyMemberDetails:
          this.familyColumnDefs = familyColDefs;
          if (Array.isArray(formInfo.formData)) {
            this.familyRowdata = formInfo.formData;
          } else {
            let arr: any = [];
            const obj: any = {};
            Object.keys(formInfo.formData).forEach((key, index) => {
              obj[key] = formInfo.formData[key];
            });
            arr.push(obj);

            this.familyRowdata = arr;
          }
          // choose col definition
          // use forminfo.formData
          break;

        case FormIdentity.nomineeMemberDetails:
          this.nomineeColumnDefs = nomineeColDefs;
          if (Array.isArray(formInfo.formData)) {
            this.nomineeRowData = formInfo.formData;
          } else {
            let arr: any = [];
            const obj: any = {};
            Object.keys(formInfo.formData).forEach((key, index) => {
              obj[key] = formInfo.formData[key];
            });
            arr.push(obj);

            this.nomineeRowData = arr;
          }

          break;
      }
    }
    this.showDetailedModal = false;

  }

  toggleCoApplicantDetails() {
    this.coapplicantDetails = !this.coapplicantDetails
  }

  toggleNomineeDetails() {
    this.nomineeDetails = !this.nomineeDetails
  }

  hideCommonFormModal() {
    this.showDetailedModal = false;
  }

  handleRowAction(event: { action: any; row: any }) {
    const { action, row } = event;
    if (event?.action === 'edit') {
      this.onEditRow(event?.row);
    } else if (event?.action === 'delete') {
      //this.onDeleteRow(row)
    }
  }


  /**
   * Edits the row data in the grid of Other Charges.
   * @param row current row to be edited
   * @returns
   */
  onEditRow(row: any) {
    if (this.selectedTaxName == null || this.selectedTaxName == "") {
      this.toastr.error("Please select the tax structure");
      return;
    }
    this.isEditOtherRow = true;
    this.discountValue = 0
    //reset the other charge form as it will again intiate with values from current row being edited of 
    //otherChargesDataRow object. This is necessary to reset it as old discount and tax calculation will be reset on the form
    this.initOtherChargeForm()

    //since user may add aditional chanrges which are non mandatory but applicable for the project like mantaininace /parking etc.
    //hence here we will send list of all charges of this project applicable for the selected unit category and payment plan
    // this.eligibleAmountSubTypeList = [...this.mandatoryAmountSubType, ...this.nonMandatoryOtherCharges]

    this.selectedRowDataToEdit = { ...row }; // Clone the data to avoid direct mutation
    if (this.selectedRowDataToEdit.action[0].popType == 'otherCharges') {
      //Set Amount rate on other charge form
      this.otherChargeForm.patchValue({
        'amountRate': this.selectedRowDataToEdit?.amountRate,
        'amount': this.selectedRowDataToEdit?.amount,
        'amountSubType': this.selectedRowDataToEdit?.amountSubTypeId ? this.selectedRowDataToEdit?.amountSubTypeId : this.selectedRowDataToEdit?.id
      })

      this.selectedOtherChargeAmountRate = this.selectedRowDataToEdit?.amountRate;

      this.selectedOtherChargesHead = this.selectedRowDataToEdit?.amount;
      this.discountValue = this.selectedRowDataToEdit?.discount;
      this.otherTaxChange(this.selectedTaxName);
      //Get eligible discounts if any for this amount sub type. 
      // In case of add it will have amount sub type id in row.id while at time of editing it will be in row.amountSubTypeId
      //because at time of editing it is showing charges from allotment payment details table while at time of adding there no'
      //record yet 
      this.getEligibleDiscounts(row.amountSubTypeId != undefined ? row.amountSubTypeId : row.id)
      this.showOtherChargesModal = true; // Show the modal

    } else if (this.selectedRowDataToEdit.action[0].popType == 'coApplicant') {
      this.showDetailedModal = true;
    }
  }

  onDeleteRow(row: any) {
    this.otherChargesRowData = this.otherChargesRowData.filter((item: any) => item.id !== row.id);
  }

  addNewOtherChargesRecord() {
    this.resetValue();
    this.showOtherChargesModal = true;
  }

  otherTaxChange(taxid: any) {
    // Find the selected tax
    const selectedTax = this.allotmentRelatedData?.taxSubTypeList.find((tax: any) => tax.id === taxid);
    const taxRate = selectedTax ? parseFloat(selectedTax.taxPercentageValue) : 0.0;

    // Calculate divided rate for CGST and SGST
    const dividedRate = taxRate / 2;
    this.dividedRateOfTaxStructure = dividedRate;
    // Calculate taxable amount
    const amount = this.selectedOtherChargesHead - this.discountValue;
    this.taxableAmount = amount;

    // Calculate CGST and SGST
    this.cgstValue = (dividedRate / 100) * amount;
    this.sgstValue = (dividedRate / 100) * amount;

    // Calculate IGST
    const igstRate = this.selectedRowDataToEdit?.igstRate || 0;
    this.igstValue = (this.taxableAmount * igstRate) / 100;

    // Calculate total taxable amount
    this.totalTaxAmount = this.igstValue + this.cgstValue + this.sgstValue;

    // Calculate gross amount and round off
    this.grossAmount = this.totalTaxAmount + this.taxableAmount;
    this.totalAmount = Math.round(this.grossAmount);
    this.roundOffGrossAmount = this.totalAmount - this.grossAmount;

    // Determine amountSubTypeId
    // const amountSubTypeId = this.selectedRowDataToEdit?.id ?? this.otherChargeForm?.value?.amountSubType;

    // Patch form values
    this.otherChargeForm.patchValue({
      amountRate: this.selectedRowDataToEdit.amountRate,
      amount: this.selectedRowDataToEdit?.amount,
      discount: this.selectedRowDataToEdit?.discount,
      taxableAmount: this.taxableAmount,
      igstRate: this.selectedRowDataToEdit?.igstRate,
      amountSubType: this.selectedRowDataToEdit?.amountSubTypeId ? this.selectedRowDataToEdit?.amountSubTypeId : this.selectedRowDataToEdit?.id,
      cgst: this.cgstValue,
      sgst: this.sgstValue,
      igst: this.igstValue,
      otherTaxType: taxid,
      taxAmount: this.totalTaxAmount,
      grossAmount: this.grossAmount,
      roundOff: this.roundOffGrossAmount,
      netAmount: this.totalAmount,
    });
  }

  onIgstChange(event: any) {
    if (event.target.value == "" || event.target.value == null) {
      event = 0;
    } else {
      event = parseFloat(event.target.value);
    }
    this.igstValue = (this.taxableAmount * event) / 100;
    this.grossAmount = this.totalTaxAmount + this.taxableAmount + this.igstValue;
    this.totalAmount = Math.round(this.grossAmount);
    this.roundOffGrossAmount = this.totalAmount - this.grossAmount;
  }

  resetValue() {
    this.taxableAmount = 0;
    this.discountValue = 0;
    this.maxDiscount = 0;
    this.sgstValue = 0;
    this.cgstValue = 0;
    this.igstValue = 0;
    this.dividedRateOfTaxStructure = 0.0;
    this.totalTaxAmount = 0;
    this.grossAmount = 0;
    this.roundOffGrossAmount = 0;
    this.isAuthForDiscount = false;
    this.otherChargeForm.reset();
    this.discoutsubTypeObject = null;
    this.isEditOtherRow = false;
    this.OtherFormSubmitted = false
    this.selectedOtherChargesHead = 0;
    this.selectedNonMandatoryOtherChargesHead = 0;
    this.selectedOtherChargeAmountRate = 0;
    this.totalAmount = 0;
    this.clearDiscounts()
  }

  getUnitCategoryObj() {
    return this.allotmentRelatedData?.unitCategoryList.find((i: any) => i.id === this.selectedUnitCategory)
  }
}
